import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  organisationId: null,
  organisation: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
